import { ReactElement, useState } from 'react'
import { SiteButton } from '../controls/SiteButton'
import { useAuth0, User } from '@auth0/auth0-react'
import { resendVerificationEmail } from '../../services/accounts'
import { useProfileContext } from '../../contexts/profileContext'

export function EmailVerification(usr: User): ReactElement {
  const [isResent, setIsResent] = useState(false)

  const { getAccessTokenSilently, logout } = useAuth0()
  const { clearProfile } = useProfileContext()

  const handleResend = () => {
    setIsResent(false)
    getAccessTokenSilently().then(async (token) => {
      resendVerificationEmail(usr.usr.sub, token)
      setTimeout(() => {
        setIsResent(true)
      }, 1500)
    })
  }

  const handleReturnToLogin = () => {
    try {
      clearProfile()
    } catch (e) {
      localStorage.removeItem('p')
    }
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <div className="flex justify-center items-center !h-auto mt-10">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md text-center">
        <h2 className="text-2xl font-semibold mb-4">Email Verification Required</h2>
        <p className="mb-4 text-credsPrimaryBlue-100 font-medium">
          Please check your inbox for an email from info@credsnow.com
        </p>
        <p className="mb-8 text-PrimaryDarkBlue-100">
          To complete your account setup, click the link in the email that has just been sent with the subject line
          "Verify your email.".
        </p>
        <p className="mb-2 text-PrimaryDarkBlue-100 text-sm">Please check your spam folder before resending email.</p>

        <div className="flex flex-col gap-3">
          <SiteButton onClick={handleResend} id="" label="Resend Email" />
          <div className="flex gap-3 justify-center mt-2">
            <SiteButton onClick={handleReturnToLogin} id="" label="Return to App" />
          </div>
        </div>

        <div>
          {isResent && (
            <div className="text-PrimaryDarkBlue-100 text-sm mt-4 bg-[#d2fda1] p-7 rounded-[8px]">
              Verification email has been <b>re-sent</b>. Please check your inbox and spam folder.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
